import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import "./FoxWashington.css";
import Location from "../../components/location/Location";
import RoomList from "../../components/roomList/RoomList";
import About from "../../components/about/About";
// import Contact from "../../components/contact/Contact";
import Intro from "../../components/intro/Intro";
import ContactInfo from "../../components/contactInfo/ContactInfo";
import SectionIntro from "../../components/sectionIntro/SectionIntro";
import IconInfo from "../../components/iconInfo/IconInfo";
import SectionPlace from "../../components/sectionPlace/SectionPlace";
import Map from "../../components/map/MapSoloPin";

const FoxWashington = () => {
  const [isMapInteractive, setIsMapInteractive] = useState(false);
  const roomState = useSelector((state) => state.room);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main role="main">
      <Intro />
      <ContactInfo />
      <SectionIntro />
      <div className="container">
        {roomState.rooms && <RoomList rooms={roomState.rooms}></RoomList>}
        {roomState.rooms.length === 0 && (
          <div className="loader">
            <ThreeDots color="#6897BB" height={50} width={50} />
          </div>
        )}
      </div>
      <SectionPlace />
      <div className="container pb-2 pb-lg-4 pt-5 pt-lg-5">
        <div
          className={`map-iframe ${isMapInteractive ? "is-interactive" : ""}`}
          onClick={() => setIsMapInteractive(true)}
          onMouseLeave={() => setIsMapInteractive(false)}
        >
          {!isMapInteractive && (
            <span className="map-iframe__hint text-center">
              Cliquez pour interagir avec la carte
            </span>
          )}

          <iframe
            src="https://www.google.com/maps/embed?pb=!4v1786623267678!6m8!1m7!1sCAoSHENJQUJJaENHN1dsXzAzUzJkOGFNeHJ2YVJyTmU.!2m2!1d50.81612346044668!2d4.374549796549655!3f21.839185096376536!4f-0.46963090175214006!5f0.7820865974627469"
            loading="lazy"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            title="Vue de la localisation"
          />
        </div>
      </div>
      <Location id="localisation" />
      <IconInfo />
      <About />
      <Map />
    </main>
  );
};

export default FoxWashington;
